import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import './App.css';
import Header from './components/Header';
import MainContent from './components/MainContent';
import Companies from './components/tabs/Companies';
import Contacts from './components/tabs/Contacts';
import Tasks from './components/tabs/Tasks';
import Users from './components/tabs/Users';
import Logs from './components/tabs/Logs';
import LoginForm from './LoginForm';
import { AuthProvider, useAuth } from './authContext';

// PrivateRoute-Komponente
const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// AdminRoute-Komponente (zentralisierte Rollenprüfung)
const AdminRoute = ({ children }) => {
  const { token, role } = useAuth();

  if (token && role === null) {
    return <div>Lade Berechtigungen...</div>;
  }

  return role === 'Admin' ? children : null;
};

// Haupt-App-Komponente
const MainApp = () => {
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="app-container">
      <Header />
      <button
        onClick={handleLogout}
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          padding: '8px 16px',
          backgroundColor: '#dc3545',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          zIndex: 1000,
        }}
      >
        Abmelden
      </button>
      <MainContent>
        <Routes>
          <Route path="/companies" element={<Companies />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route
            path="/users"
            element={
              <AdminRoute>
                <Users />
              </AdminRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <AdminRoute>
                <Logs />
              </AdminRoute>
            }
          />
          {/* Standard-Route: Leite zu /tasks weiter */}
          <Route path="/" element={<Navigate to="/tasks" replace />} />
        </Routes>
      </MainContent>
    </div>
  );
};

// Haupt-App mit Routing
const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <MainApp />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;